export default __webpack_public_path__ + "static/media/about-team-24.90be2b17.jpg";